<template>
    <div class="pr-1">
        <img src="@/assets/svg/copy.svg" alt="copy" class="copy copy-occupancy" @click="copyOccupancy">
    </div>
</template>

<script>
import Price from '@/services/hatsApi/Price'
import Language from '@/services/hatsApi/Language'
import Service from '@/services/hatsApi/Service'

export default {
  data () {
    return {
      prices: [],
      serviceTypes: [],
      service: null
    }
  },
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  methods: {
    async copyOccupancy () {
      // console.log('copy click', this.$route.params.service_type, this.$route.params.id, this.$route.params.occupancy_type, this.row.id)

      this.service = this.row
      await Service.getServiceTypes().then((response) => {
        this.serviceTypes = response.data.data
      })

      let filter = [
        {
          property: 'serviceId',
          value: this.row.id
        }
      ]
      // add new occupancy
      let occupancyId = await this.addNewOccupancy()
      if (occupancyId) {
        // get added occupancy
        const serviceResponse = await Service.getService(occupancyId)
        if (serviceResponse.data.success) {
          this.service = serviceResponse.data.data
          this.$offlineStorage.set('serviceType', this.service)
        }
        // get prices & set it to a new occupancy
        const basePriceResponse = await Price.getBasePrices(filter)
        this.service.basePrices = basePriceResponse.data.data
        this.service.basePrices.forEach((item, key) => {
          this.service.basePrices[key].new = true
        })
        // get ages, paxes, offers and full booked & set it to a new occupancy
        const priceRulesResponse = await Price.getPriceRules(filter)
        this.service.priceRules = priceRulesResponse.data.data
        this.service.priceRules.forEach((item, key) => {
          this.service.priceRules[key].new = true
        })

        try {
          await Service.updateService(this.service)
        } catch (e) {
          console.error(e)
        }
      }
      this.serviceSaved(occupancyId)
    },
    async addNewOccupancy () {
      try {
        let newService = this.service
        // Service info does not have fields to fill in titles
        try {
          let languageResponse = await Language.getLanguages()
          this.$_.forEach(languageResponse.data.data, function (language) {
            newService['title_' + language.code] = newService.name + ' [copy]'
          })
        } catch (error) {
          console.log(error)
        }
        // Set the service type
        let serviceType = this.$_.find(this.serviceTypes, {'code': this.$route.params.service_type.toUpperCase()})
        let occupancyType = this.$_.find(this.serviceTypes, {'code': this.$route.params.occupancy_type.toUpperCase()})
        if (serviceType.id && occupancyType.id) {
          newService.serviceIdParent = parseInt(this.$route.params.id)
          newService.serviceTypeId = occupancyType.id
        }
        if (!newService.code) {
          newService.code = 'TST99_COPY'
        } else {
          newService.code += '_COPY'
        }
        let response = await Service.createService(newService)
        if (response.data.success) {
          // this.serviceSaved(response.data.data.id)
          return response.data.data.id
        }
      } catch (error) {
        console.log(error)
      }
    },
    serviceSaved (id) {
      if (id) {
        this.$router.push({path: '/services/' + this.$route.params.service_type + '/' + this.$route.params.id + '/room_type/' + id})
      }
    }
  }
}
</script>

<style>
  .copy-occupancy {
    width: 15px;
    height: 15px
  }
  .copy-occupancy:hover {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/datatable/OccupancyTypeCopyButton.vue